export const bindPanelDetails = (el, onModeChange) => {
    const parent = getPanelModeParent(el);
    parent === null || parent === void 0 ? void 0 : parent.attachPanelDetailsListener(onModeChange);
    return () => {
        parent === null || parent === void 0 ? void 0 : parent.detachPanelDetailsListener(onModeChange);
    };
};
const getPanelModeParent = (child) => {
    const modeParent = (node) => {
        const parent = findParent(node);
        if (!parent)
            return null;
        if (isPanelModeElement(parent))
            return parent;
        return modeParent(parent);
    };
    return modeParent(child);
};
const isPanelModeElement = (node) => 'attachPanelDetailsListener' in node &&
    'attachPanelDetailsListener' in node;
const findParent = (node) => {
    var _a, _b, _c, _d, _e, _f;
    return node.assignedSlot
        ? ((_c = (_a = node.assignedSlot.parentElement) !== null && _a !== void 0 ? _a : (_b = node.assignedSlot.parentNode) === null || _b === void 0 ? void 0 : _b.parentElement) !== null && _c !== void 0 ? _c : node.assignedSlot.getRootNode().host)
        : ((_f = (_d = node.parentElement) !== null && _d !== void 0 ? _d : (_e = node.parentNode) === null || _e === void 0 ? void 0 : _e.parentElement) !== null && _f !== void 0 ? _f : node.getRootNode().host);
};
//# sourceMappingURL=panelDetails.js.map
